// extracted by css-extract-rspack-plugin
export default {"tooltip":"cxcrafSe8ysgidEG"};